import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { Map } from 'immutable';

import { ProjectActions } from '../actions/project';
import { ElementActions } from '../actions/element';
import { ElementTypeActions } from '../actions/elementType';
import { ViewActions } from '../actions/view';
import {
  currentElementSelector,
} from './elements';

const projectActions = getActionIds(ProjectActions);
const elementActions = getActionIds(ElementActions);
const elementTypeActions = getActionIds(ElementTypeActions);
const viewActions = getActionIds(ViewActions);


const initialState = Immutable.fromJS({
  elementTypes: {},
  loading: {
    // tags: [],
    comments: []
  },
  loaded: {
    // tags: [],
    comments: []
  },
  meta: {
    sortType: null
  }
});

export const elementTypes = createStore(initialState, {
  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [projectActions.setIcon.success]: (state, action) => {
    const componentType = action.result.result.componentType;

    if (componentType !== 'elementTypes') return state;

    return state.mergeDeep({
      elementTypes: {
        [action.result.result.componentId]: {
          icon_id: action.result.result.iconId
        }
      }
    });
  },

  [viewActions.getView.success]: (state, action) => {
    if (!action.result.entities.types) return state;
    return state.mergeDeep({
      elementTypes: action.result.entities.types
    });
  },

  [projectActions.getRootElement.success]: (state, action) => {
    return state.mergeDeep({
      elementTypes: action.result.entities.types
    });
  },

  [elementTypeActions.updatePropsOrder]: (state, action) => {
    const elementTypeId = action.elementTypeId;
    const hoverKey = action.hoverKey;
    const dragKey = action.dragKey;
    const hoverOrder = state.getIn(['elementTypes', elementTypeId, 'props', hoverKey, '_order']);
    const dragOrder = state.getIn(['elementTypes', elementTypeId, 'props', dragKey, '_order']);

    const newProps = state.getIn(['elementTypes', elementTypeId, 'props']).map((prop, key) => {
      const propOrder = prop.get('_order');

      if (key === dragKey) {
        return prop.set('_order', hoverOrder);
      }

      if (propOrder <= hoverOrder && propOrder >= dragOrder) {
        return prop.set('_order', propOrder - 1);
      }

      if (propOrder >= hoverOrder && propOrder <= dragOrder) {
        return prop.set('_order', propOrder + 1);
      }

      return prop;
    });

    return state.mergeDeep({
      elementTypes: {
        [elementTypeId]: {
          props: newProps
        }
      }
    });
  },

  [elementTypeActions.deleteElementTypeMetaProperty.success]: (state, action) => {
    return state.deleteIn(['elementTypes', action.result.elementtype_id.toString(), 'props', action.result.prop, action.result.meta_key]);
  },

  [elementTypeActions.saveElementTypeProperty.success]: (state, action) => {
    return state.mergeDeep({
      elementTypes: {
        [action.result.id]: {
          props: action.result.props
        }
      }
    });
  },

  [elementTypeActions.renameElementType.success]: (state, action) => {
    return state.mergeDeep({
      elementTypes: {
        [action.result.result]: {
          type: action.result.entities.elementTypes[action.result.result].type
        }
      }
    });
  },

  [elementTypeActions.createElementTypeProperty.success]: (state, action) => {
    return state.mergeDeep({
      elementTypes: {
        [action.result.id]: {
          props: action.result.props
        }
      }
    });
  },

  [elementTypeActions.deleteElementType.success]: (state, action) => {
    return state.deleteIn(['elementTypes', action.result.elementTypeId.toString()]);
  },

  [elementTypeActions.deleteElementTypeProperty.success]: (state, action) => {
    return state.deleteIn(['elementTypes', action.result.elementtype_id.toString(), 'props', action.result.deleted_key]);
  },

  [elementTypeActions.createElementType.success]: (state, action) => {
    return state.mergeDeep({
      elementTypes: {
        [action.result.result]: action.result.entities.elementTypes[action.result.result]
      }
    });
  },

  [elementTypeActions.updateElementTypeProperties.success]: (state, action) => {
    const elementTypeId = action.result.id;

    return state.setIn(
      ['elementTypes', elementTypeId, 'props'],
      Immutable.fromJS(action.result.props)
    );

    // return state.mergeDeep({
    //   elementTypes: {
    //     [elementTypeId]: {
    //       props: Immutable.fromJS(action.result.props)
    //     }
    //   }
    // });

    // return state;
  },

  [projectActions.sortData]: (state, action) => {
    const sortOn = action.sortOn;

    if (sortOn !== 'elementTypes') return state;

    const sortType = action.sortType;

    let elementTypes = state.get('elementTypes').sort((a, b) => {
      let lowerCaseA = a.get('type').toLowerCase();
      let lowerCaseB = b.get('type').toLowerCase();

      switch (sortType) {
        case 'ascending':
          if (lowerCaseA < lowerCaseB) {
            return -1;
          } else if (lowerCaseA > lowerCaseB) {
            return 1;
          } else {
            return 0;
          }
        case 'descending':
          if (lowerCaseA < lowerCaseB) {
            return 1;
          } else if (lowerCaseA > lowerCaseB) {
            return -1;
          } else {
            return 0;
          }
        case 'date':
          if (a.get('created_at') > b.get('created_at')) {
            return -1;
          } else if (a.get('created_at') < b.get('created_at')) {
            return 1;
          } else {
            return 0;
          }
        default:
          return 0;
      }
    });

    return state.merge({
      elementTypes: elementTypes,
      meta: {
        sortType: sortType
      }
    });
  },

  [elementTypeActions.getProjectElementTypes.begin]: (state, action) => {
    return state.mergeDeep({
      loading: {
        all: true
      }
    });
  },

  [elementTypeActions.getProjectElementTypes.success]: (state, action) => {
    if (!action.result.entities.elementTypes) return state;

    return state.mergeDeep({
      elementTypes: action.result.entities.elementTypes,
      loading: {
        all: false
      },
      loaded: {
        all: true
      }
    });
  },

  [elementTypeActions.getElementType.success]: (state, action) => {
    if (!action.result.entities.elementTypes) return state;
    return state.mergeDeep({
      elementTypes: action.result.entities.elementTypes
    });
  },

  [elementTypeActions.createElementTypeMetaProperty.success]: (state, action) => {
    const elementTypeId = action.result.elementtype_id.toString();
    // const currentElementTypeProps = state.getIn(['elementTypes', elementTypeId, 'props']);
    // const oldPropData = currentElementTypeProps.get(action.result.deleted_key);
    // let updatedElementTypeProps = currentElementTypeProps.delete(action.result.deleted_key);
    // updatedElementTypeProps = updatedElementTypeProps.set(action.result.new_key, oldPropData);
    // const oldPropData = state.get('')
    return state.setIn(['elementTypes', elementTypeId, 'props', action.result.prop, action.result.meta_key], Immutable.fromJS(action.result.meta_value));
  },

  [elementTypeActions.renameElementTypeProperty.success]: (state, action) => {
    const elementTypeId = action.result.elementtype_id.toString();
    const currentElementTypeProps = state.getIn(['elementTypes', elementTypeId, 'props']);
    const oldPropData = currentElementTypeProps.get(action.result.deleted_key);
    let updatedElementTypeProps = currentElementTypeProps.delete(action.result.deleted_key);
    updatedElementTypeProps = updatedElementTypeProps.set(action.result.new_key, oldPropData);
    return state.setIn(['elementTypes', elementTypeId, 'props'], updatedElementTypeProps);
  },

  [elementTypeActions.renameElementTypeMetaProperty.success]: (state, action) => {
    const elementTypeId = action.result.elementtype_id.toString();
    const currentElementTypeMetaProps = state.getIn(
      ['elementTypes', elementTypeId, 'props', action.result.prop]
    );

    const oldMetaData = currentElementTypeMetaProps.get(action.result.deleted_meta_key);
    const updatedElementTypeMetaProps = currentElementTypeMetaProps
      .delete(action.result.deleted_meta_key)
      .set(action.result.new_meta_key, oldMetaData);

    return state.setIn(
      ['elementTypes', elementTypeId, 'props', action.result.prop],
      updatedElementTypeMetaProps
    );
  },

  [elementTypeActions.saveDescription.success]: (state, action) => {
    return state.mergeDeep({
      elementTypes: {
        [action.result.result]: {
          description: action.result.entities.elementTypes[action.result.result].description
        }
      }
    });
  },

  [elementActions.getElement.success]: (state, action) => {
    if (!action.result.entities.types) return state;
    return state.mergeDeep({
      elementTypes: action.result.entities.types
    });
  }
});

export const getElementTypeById = (allElementTypes, taskTypeId) => {
  return allElementTypes.get(taskTypeId);
};

export const currentElementTypeByElementSelector = (state, props) => {
  const currentElement = currentElementSelector(state, props);
  const currentElementTypeId = currentElement.get('type_id', null);
  return state.elementTypes.getIn(['elementTypes', currentElementTypeId], null);
};

export const currentElementTypeIdSelector = (state, props) => {
  return props.currentElementTypeId || (
    (props.routeParams) ?
      props.routeParams.elementTypeId :
      null
    );
};

export const currentElementTypeSelector = (state, props) => {
  const currentElementTypeId = currentElementTypeIdSelector(state, props);

  return state.elementTypes.getIn(['elementTypes', currentElementTypeId], Map());
};

export const elementTypesSelector = (state, props) => {
  return state.elementTypes.get('elementTypes', Map());
};

export const taskTypeIdSelector = (state, props) => {
  const taskType = state.elementTypes.get('elementTypes').find((a) => {
    return a.get('type') === 'Task';
  });

  return taskType ? taskType.get('id') : null;
};

export const issueTypeIdSelector = (state, props) => {
  const issueType = state.elementTypes.get('elementTypes').find((a) => {
    return a.get('type') === 'Issue';
  });

  return issueType ? issueType.get('id') : null;
};

export const WbsTypeIdSelector = (state, props) => {
  const taskType = state.elementTypes.get('elementTypes', Map()).find((a) => {
    return a.get('type') === 'Work Breakdown Structure';
  });

  return taskType ? taskType.get('id') : null;
};

export const milestoneTypeIdSelector = (state, props) => {
  const milestoneType = state.elementTypes.get('elementTypes').find((a) => {
    return a.get('type') === 'Milestone';
  });

  return milestoneType ? milestoneType.get('id') : null;
};

export const shouldLoadElementTypesSelector = (state) =>
  !state.elementTypes.getIn(['loading', 'all']) && !state.elementTypes.getIn(['loaded', 'all']);

export const sortSelector = (state) =>
  state.elementTypes.getIn(['meta', 'sortType']);



// WEBPACK FOOTER //
// ./src/reducers/elementTypes.js